import React, { Component } from 'react';
import ReactLoading from 'react-loading';

class Loader extends Component {

    render() {
        return (
            <div style={{ display: 'flex', width: '100%', height: 400, alignItems: 'center', justifyContent: 'center' }}>
                <ReactLoading type="spinningBubbles" color="#40b508" height={100} width={100} />
            </div>       
        );
    }
}

export default Loader;




// WEBPACK FOOTER //
// ./src/components/common/Loader.js